import { ApiCore } from "./utilities/core";

const url = 'dashboard/export_dataframe';

const apiVariantExplorerData = new ApiCore({
    getAll: false,
    getSingle: false,
    post: false,
    postSingle: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
});

export default apiVariantExplorerData;